export default "__VITE_ASSET__X75ncE37__"